import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Spinner } from 'reactstrap';
import Translate from '../common/Translate';
import useRecord from '../../Store/uses/useRecord';
import { Auth } from '../../config/configuration/react';
import Header from '../common/Header/Header';
import Banner from '../common/Header/Banner';
import {
  MarketBloc,
  PricingBloc,
  InspectionBloc,
  TradeBloc,
  FinalBloc,
  AppointmentBloc,
  ActionButton,
  VehicleBloc,
  GuranteedPriceBloc,
  CounterAppraisalBloc,
} from './RecordBlocs';
import SubHeader from '../common/Header/SubHeader';
import { useGuaranteedPrice } from '../../hooks/useGuaranteedPrice/useGuaranteedPrice';
import { NRM_SUB_STATUS } from '../../config';
import { TradeModal } from './Elements/TradeModal';

export const Record = (props) => {
  let { recordId } = useParams();
  recordId = parseInt(recordId, 10);
  const {
    isRecordLoading,
    errorRecordApi,
    recordEntity,
    formId,
    vehicleId,
    counterInspectionHasConfigForm,
    autobizTradeDate,
  } = useRecord(recordId, 'all');
  const displayBlocs = recordEntity.displayBlocsIsAllowed();
  const displayBlocAppraisal = recordEntity.displayBlocAppraisalIsAllowed();
  const b2bCounterAppraisalEnabled = recordEntity.counterAppraisalEnabled();
  const b2bManualDecisionEnabled = recordEntity.manualDecisionEnabled();
  const b2bCounterAppraisalRequired = recordEntity.counterAppraisalRequired();
  const displayVehicle = recordEntity.displayVehicleIsAllowed();
  const isNrmRecord = recordEntity.isNrmRecord();
  const isNrmUser = Auth.isNrmUser();
  const isCarcheckUser = Auth.isCarcheckUser();
  const isOnlyNrmUser = Auth.isOnlyNrmUser();
  const { tradeInWithOrderId } = NRM_SUB_STATUS;
  const { handleKeepCar, supervisor, guaranteedPrice, nrmStatusId } = useGuaranteedPrice(recordId);
  const actions = [{ id: 'light_form' }, { id: 'full_form' }];

  function isDiffGreaterThan48Hours(startAt) {
    const date1 = new Date(startAt);
    const date2 = new Date();
    const diffInMs = Math.abs(date2 - date1);
    const diffInHours = diffInMs / 1000 / 60 / 60;
    return diffInHours >= 48;
  }
  useEffect(() => {
    if (
      isDiffGreaterThan48Hours(supervisor?.keepCarDecisionDate?.date) &&
      supervisor?.keepCar === null &&
      nrmStatusId === tradeInWithOrderId
    ) {
      handleKeepCar(guaranteedPrice.nrmRecordId, false, false);
    }
  }, []);

  return (
    <>
      <Header {...props} title="Carcheck" iconBackbutton={false} />
      <Banner />
      <SubHeader {...props} title="Carcheck" iconBackbutton={false} />
      <div className="pseudo-white-bg" />
      {errorRecordApi && (
        <p className="ml-2 text-danger">
          <Translate code={errorRecordApi} />
        </p>
      )}
      <div className="pseudo-grey-bg mt-4">
        <AppointmentBloc recordId={recordId} />
      </div>
      <div className="calendar-meeting-folder-container">
        <Row className="py-2">
          {displayVehicle && <VehicleBloc recordId={recordId} />}
          {displayBlocs && <InspectionBloc formId={formId} recordId={recordId} />}
          {displayBlocAppraisal && isCarcheckUser && (
            <>
              <MarketBloc recordId={recordId} />
              <PricingBloc recordId={recordId} />
            </>
          )}
          {displayBlocAppraisal && isNrmRecord && isNrmUser && <GuranteedPriceBloc recordId={recordId} />}
          {displayBlocAppraisal &&
            ((isNrmRecord && isNrmUser) ||
              (!isNrmRecord &&
                b2bCounterAppraisalEnabled &&
                (!b2bManualDecisionEnabled || b2bCounterAppraisalRequired))) && (
              <CounterAppraisalBloc recordId={recordId} />
            )}
          {displayBlocAppraisal && (
            <>
              <FinalBloc recordId={recordId} />
            </>
          )}
          {displayBlocs && !isOnlyNrmUser && (
            <TradeBloc tradeId={vehicleId} recordId={recordId} autobizTradeDate={autobizTradeDate} />
          )}

          {/* <FolderSection title={t("histovec")}>
            {data.histovec && <List values={data.histovec} />}
          </FolderSection>

          <FolderSection title={t("alerts")}>
            {data.alerts && (
              <div className="calendar-data-folder-alerts">
                {data.alerts.danger && data.alerts.danger > 1 && (
                  <>
                    <span className="circle circle-red">
                      {data.alerts.danger}
                    </span>
                    {t("danger")}
                  </>
                )}
                {data.alerts.danger && data.alerts.danger > 1 && (
                  <>
                    <span className="circle circle-orange">
                      {data.alerts.critical}
                    </span>
                    {t("critical")}
                  </>
                )}
                {data.alerts.danger && data.alerts.danger > 1 && (
                  <>
                    <span className="circle circle-grey">
                      {data.alerts.moderate}
                    </span>
                    {t("moderate")}
                  </>
                )}
              </div>
            )}
          </FolderSection>

          <FolderSection title={t("repurchase")}>
            {data.repurchase && (
              <LabelValue
                label={t("current_offer")}
                value={`${t(data.repurchase.current_offer)} €`}
              />
            )}
          </FolderSection>  */}
        </Row>
        <Row>
          <Col className="d-flex justify-content-center">
            {b2bCounterAppraisalEnabled &&
            recordEntity.type() === 2 &&
            recordEntity.status() === 1 &&
            counterInspectionHasConfigForm ? (
              actions.map((action) => <ActionButton label={action.id} recordId={recordId} formId={formId} />)
            ) : (
              <ActionButton recordId={recordId} formId={formId} />
            )}
          </Col>
        </Row>
      </div>
      {isRecordLoading && (
        <div className="loader-full-screen main">
          <Spinner />
        </div>
      )}
      <TradeModal />
    </>
  );
};
